import { Box, Tab } from '@mui/material';

import Layout from '../layout';
import Block from '../../../components/block';
import React from 'react';
import { TabContext, TabList, TabPanel } from '@mui/lab';

function Operations() {
  const [value, setValue] = React.useState('1');

  const handleChange = (_event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  return (
    <div>
      <Layout>
        <Box sx={{ width: '100%', typography: 'body1' }}>
          <TabContext value={value}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <TabList onChange={handleChange} aria-label="lab API tabs example">
                <Tab label="Все" value="1" />
                <Tab label="Доходы" value="2" />
                <Tab label="Расходы" value="3" />
              </TabList>
            </Box>
            <TabPanel value="1">
              <Block type={'all'} />
            </TabPanel>
            <TabPanel value="2">
              <Block type={'income'} />
            </TabPanel>
            <TabPanel value="3">
              <Block type={'expense'} />
            </TabPanel>
          </TabContext>
        </Box>
      </Layout>
    </div>
  );
}

export default Operations;
